import { createInstance } from '@amplitude/analytics-browser';
import { DefaultConfiguration, ampli } from '../../ampli/index';

import { getActiveReactPage, getEnvironment } from './utils';

export const resetAmplitudeSession = () => ampli.flush();

/**
 * This plugin enriches events by updating necessary event properties.
 *
 * @returns EnrichmentPlugin
 */
export const trackingEnrichmentPlugin = () => ({
  name: 'page-view-tracking-enrichment',
  setup: async () => undefined,
  type: 'enrichment',
  execute: async (event) => {
    if (event.event_type === '[Amplitude] Page Viewed') {
      // The enrichment is necessary because Amplitude page view event runs 
      // before react-helmet's page title is updated, leading to stale
      // page title in the event properties object.
      
      const page = getActiveReactPage();

      // Customize page view events to make sense when performing analytics.
      event.event_type = `Viewed ${page.title} Page`;
      
      event.event_properties = {
        ...event.event_properties,
        '[Amplitude] Page Title': page.title
      };
    } else if (!event?.user_id) {
      // This enrichment attempts to identify or block unidentified events.
      // A scenario is an event triggered after the user is logged out.
      const userId = window?.EMAIL;
      if (!userId) return null;
      event.user_id = userId;
    }

    return event;
  },
});

export const identifyAmplitudeUser = () => {
  const email = window?.EMAIL ?? '';
  ampli.identify(email);
};

export const loadAmplitude = () => {
  const activeEnvironment = getEnvironment();

  const configuration = {
    fetchRemoteConfig: true,
    autocapture: {
      elementInteractions: false,
      formInteractions: false,
      fileDownloads: false,
      attribution: false,
      sessions: false,
      pageViews: true
    }
  };

  const environment = {
    production: 'formplusproduction',
    development: 'formpluslocalhost',
    staging: 'formplusstaging'
  }[activeEnvironment];

  const apiKey = {
    development: '87c69de007ff2f4caa204837d229849e',
    // production: '80b0de0573e0e2290c4707defa48e66b',  //  This will be activated when remaining events have been added in v50.
    production: '0fc81a7dc85ee50e412d305f238b87f2',
    staging: '0fc81a7dc85ee50e412d305f238b87f2'
  }[activeEnvironment];
  
  const instance = createInstance();

  instance.add(trackingEnrichmentPlugin());

  instance.init(apiKey, undefined, {
    ...DefaultConfiguration,
    ...configuration
  });

  const client = { instance };
  ampli.load({ client });

  console.log('Amplitude initialized successfully!');
};

export const Ampli = ampli;